import { Image, Space } from 'antd';
import PropTypes from 'prop-types';
import { LocationDateComponent } from './LocationDateComponent';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';
import constants from '../../../../config/api/constants';
import { TitleSummary } from '../../style';

export const SignatureComponent = ({ field }) => {
  const { translate: t } = useDictionaryTranslation();
  const urlImage = constants.s3UrlPath;

  return (
    <>
      <Space key={field.idInput} direction="vertical">
        <TitleSummary>{t(field.label)}</TitleSummary>
        {field?.value ? (
          <>
            <Image width={200} height={200} src={`${urlImage}/${field?.value?.filename}`} />
            <LocationDateComponent field={field} />
          </>
        ) : (
          <p >{t('noAttachments')}</p>
        )}
      </Space>
    </>
  );
};

SignatureComponent.propTypes = {
  field: PropTypes.object.isRequired,
};
